import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Modal/sgds-modal";
import { register } from "../../utils/ce-registry";

register("sgds-modal", Component);

export default createComponent({
  react: React,
  tagName: "sgds-modal",
  elementClass: Component,
  events: {
    onSgdsClose: "sgds-close",
    onSgdsShow: "sgds-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsAfterHide: "sgds-after-hide"
  }
});
